(() => {
  let teardown;
  function initialize() {
    const root=document.getElementById('rx-home');
    if(!root||root.dataset.initialized)return;
    if(teardown)teardown();
    const content=JSON.parse(root.querySelector('#rx-content-data').textContent);
    const abort=new AbortController(),observers=[],frames=new Set(),timeouts=new Set();
    const listen=(target,event,callback,options={})=>target.addEventListener(event,callback,{...options,signal:abort.signal});
    const requestAnimationFrame=callback=>{const id=window.requestAnimationFrame(time=>{frames.delete(id);if(root.isConnected)callback(time);});frames.add(id);return id;};
    const cancelAnimationFrame=id=>{frames.delete(id);window.cancelAnimationFrame(id);};
    const setTimeout=(callback,delay)=>{const id=window.setTimeout(()=>{timeouts.delete(id);if(root.isConnected)callback();},delay);timeouts.add(id);return id;};
    const IntersectionObserver=class extends window.IntersectionObserver{constructor(...args){super(...args);observers.push(this);}};
    const ResizeObserver=class extends window.ResizeObserver{constructor(...args){super(...args);observers.push(this);}};
    const MutationObserver=class extends window.MutationObserver{constructor(...args){super(...args);observers.push(this);}};
    teardown=()=>{abort.abort();observers.forEach(o=>o.disconnect());frames.forEach(id=>window.cancelAnimationFrame(id));timeouts.forEach(id=>window.clearTimeout(id));};

(function(){
  const root=document.getElementById('rx-home');
  if(!root||root.dataset.initialized)return;
  root.dataset.initialized='true';
  const q=s=>root.querySelector(s),qa=s=>Array.from(root.querySelectorAll(s));
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile=q('#rx-mobile-nav'),menu=q('.rx-menu-button');
  listen(menu,'click',()=>{const open=menu.getAttribute('aria-expanded')==='true';menu.setAttribute('aria-expanded',String(!open));mobile.hidden=open;menu.firstChild.textContent=open?content.labels.menu+' ':content.labels.close+' ';});
  listen(root,'click',e=>{const a=e.target.closest('a[href^="#rx-"]');if(!a)return;const target=q(a.getAttribute('href'));if(!target)return;e.preventDefault();mobile.hidden=true;menu.setAttribute('aria-expanded','false');menu.firstChild.textContent=content.labels.menu+' ';if(root.rxNavigate)root.rxNavigate(target);else target.scrollIntoView({behavior:reduced.matches?'auto':'smooth',block:'start'});});
  if('IntersectionObserver' in window){root.classList.add('rx-ready');const reveal=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('rx-visible');reveal.unobserve(e.target);}}),{threshold:.08});qa('.rx-reveal').forEach(el=>reveal.observe(el));setTimeout(()=>qa('.rx-hero .rx-reveal').forEach(el=>el.classList.add('rx-visible')),60);}
  let ecoIndex=0,ecoAngle=0;
  const ecoLabels=[['Clinical','practice'],['Scientific','intelligence'],['Everyday','action']];
  qa('[data-eco]').forEach(b=>listen(b,'click',()=>{const index=Number(b.dataset.eco);ecoAngle+=((index-ecoIndex+3)%3)*120;ecoIndex=index;q('.rx-eco-orbit').style.transform='rotate('+ecoAngle+'deg)';qa('[data-eco]').forEach((button,i)=>{const active=index===i;button.setAttribute('aria-expanded',String(active));button.lastElementChild.textContent=active?'−':'+';q('#rx-eco-answer-'+i).hidden=!active;});qa('[data-node]').forEach((n,i)=>n.classList.toggle('is-active',i===index));q('#rx-eco-core-text').replaceChildren(document.createTextNode(ecoLabels[index][0]),document.createElement('br'),document.createTextNode(ecoLabels[index][1]));}));
  const products=content.products;
  function selectProduct(key){const p=products[key];p.heading=p.heading.map(line=>line.trim());qa('.rx-product-tab').forEach(t=>{t.setAttribute('aria-selected',String(t.dataset.product===key));t.tabIndex=t.dataset.product===key?0:-1;});const panel=q('#rx-product-panel');panel.setAttribute('aria-labelledby','rx-tab-'+key);q('#rx-product-audience').textContent=p.audience;q('#rx-product-heading').replaceChildren(document.createTextNode(p.heading[0]),document.createElement('br'),document.createTextNode(p.heading.slice(1).join(' ')));q('#rx-product-copy').textContent=p.copy;const link=q('#rx-product-link');link.firstElementChild.textContent=p.link;link.href=p.href;if(p.href.startsWith('https:')){link.target='_blank';link.rel='noopener noreferrer';}else{link.removeAttribute('target');link.removeAttribute('rel');}link.dataset.product=key;root.dispatchEvent(new CustomEvent('rx:platform',{detail:{key}}));panel.classList.remove('rx-changing');void panel.offsetWidth;panel.classList.add('rx-changing');}
  qa('.rx-product-tab').forEach((t,i,arr)=>{listen(t,'click',()=>selectProduct(t.dataset.product));listen(t,'keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%arr.length;else if(e.key==='ArrowLeft')n=(i-1+arr.length)%arr.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=arr.length-1;else return;e.preventDefault();arr[n].focus();selectProduct(arr[n].dataset.product);});});
  const enquiries=content.enquiries;
  let enquiry='Investors';
  function openEnquiry(type){enquiry=type;const info=enquiries[type];q('#rx-enquiry-panel').hidden=false;q('#rx-enquiry-title').textContent=info[0];q('#rx-enquiry-description').textContent=info[1];qa('[data-enquiry]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.enquiry===type)));q('#rx-enquiry-type').value=type;}
  qa('[data-enquiry]').forEach(b=>listen(b,'click',()=>openEnquiry(b.dataset.enquiry)));
  listen(q('#rx-product-link'),'click',function(){if(this.getAttribute('href')==='#rx-contact')openEnquiry('Clinics');});
  listen(q('.rx-close'),'click',()=>{q('#rx-enquiry-panel').hidden=true;qa('[data-enquiry]').forEach(b=>b.setAttribute('aria-pressed','false'));});
  if(q('[data-contact-result]')){openEnquiry('Investors');setTimeout(()=>root.rxNavigate?.(q('#rx-contact')),120);}
  const canvas=q('#rx-science-canvas'),ctx=canvas.getContext('2d');
  const svg=q('#rx-ribbons'),mesh=q('#rx-ribbon-mesh'),accents=q('#rx-ribbon-accent'),bands=q('.rx-scroll-bands');
  const ns='http://www.w3.org/2000/svg',sections=qa('main > section'),footer=q('.rx-footer'),page=q('#rx-page-stage');
  let width=0,height=0,artWidth=0,artHeight=0,readY=0,targetY=0,viewTop=0,viewBottom=650,raf=0,lastDraw=0,paused=reduced.matches,layoutBusy=false;
  let anchors=[],sectionPositions=[],observer=null,visibleBands=new Map(),lastBandCount=0;
  const fibres=[],traces=[],heads=[];
  const heroDuration=4600;
  let heroElapsed=0,heroStarted=false,heroOnScreen=false;
  const heroRunning=()=>heroStarted&&heroOnScreen&&heroElapsed<heroDuration&&!reduced.matches;
  function create(tag,attrs,parent){const el=document.createElementNS(ns,tag);Object.entries(attrs).forEach(([k,v])=>el.setAttribute(k,String(v)));parent.appendChild(el);return el;}
  for(let family=0;family<2;family++){
    const paths=[];
    for(let i=0;i<24;i++)paths.push(create('path',{fill:'none',stroke:family?'#6874b3':'#7e849c','stroke-width':family?.68:.82,'stroke-opacity':family?.11:.16,'vector-effect':'non-scaling-stroke'},mesh));
    fibres.push(paths);
    traces.push(create('path',{fill:'none',stroke:family?'#0d1fb6':'#c65d56','stroke-width':1.08,'stroke-opacity':family?.34:.27,'vector-effect':'non-scaling-stroke'},accents));
    heads.push(create('circle',{r:2.35,fill:family?'#0d1fb6':'#c65d56',opacity:.48},accents));
  }
  const limit=(x,a=0,b=1)=>Math.max(a,Math.min(b,x));
  function localTop(el){return el.getBoundingClientRect().top-page.getBoundingClientRect().top;}
  function interpolate(y){
    let i=0;while(i<anchors.length-2&&y>anchors[i+1].y)i++;
    const p0=anchors[Math.max(0,i-1)],p1=anchors[i],p2=anchors[i+1],p3=anchors[Math.min(anchors.length-1,i+2)];
    const t=limit((y-p1.y)/Math.max(1,p2.y-p1.y)),t2=t*t,t3=t2*t;
    return .5*((2*p1.x)+(-p0.x+p2.x)*t+(2*p0.x-5*p1.x+4*p2.x-p3.x)*t2+(-p0.x+3*p1.x-3*p2.x+p3.x)*t3);
  }
  function ribbon(y,strand,family,phase){
    const u=y/Math.max(1,height),primary=interpolate(y),base=family?width-primary*.91:primary;
    const spread=width*(width<651?.25:.245)*(1+.35*Math.sin(u*22+phase*.23+family));
    const turn=Math.cos(u*19+phase*.20+family*1.7);
    const breathe=Math.sin(u*15+phase*.32+family)*width*.021;
    return base+breathe+strand*spread*turn+Math.sin(strand*2.3+u*14+family)*width*.032;
  }
  function smoothPath(points){
    if(!points.length)return '';
    const pair=p=>p[0].toFixed(1)+','+p[1].toFixed(1);
    let d='M'+pair(points[0]);
    for(let i=1;i<points.length-1;i++){const p=points[i],next=points[i+1];d+='Q'+pair(p)+' '+pair([(p[0]+next[0])/2,(p[1]+next[1])/2]);}
    if(points.length>1)d+='L'+pair(points[points.length-1]);return d;
  }
  function background(){
    if(!width||!height)return;
    const phase=readY/height*9,samples=Math.max(105,Math.ceil(height/39)),step=height/samples;
    const progressY=reduced.matches?height:limit(readY,0,height);
    fibres.forEach((paths,family)=>{
      paths.forEach((path,i)=>{
        const strand=(i/(paths.length-1)-.5)*2,points=[];
        for(let n=0;n<=samples;n++){const y=n*step,x=ribbon(y,strand,family,phase);points.push([x,y]);}
        path.setAttribute('d',smoothPath(points));
      });
      const points=[];for(let y=0;y<progressY;y+=step)points.push([ribbon(y,0,family,phase),y]);
      const headX=ribbon(progressY,0,family,phase);points.push([headX,progressY]);traces[family].setAttribute('d',smoothPath(points));
      heads[family].setAttribute('cx',headX);heads[family].setAttribute('cy',progressY);heads[family].style.opacity=reduced.matches?'0':'.48';
    });
    sectionPositions.forEach(({el,top,bottom})=>el.style.setProperty('--rx-section-read',limit((readY-top)/Math.max(1,bottom-top)).toFixed(3)));
    root.dataset.scrollProgress=(readY/height).toFixed(4);
  }
  function sculpture(){
    if(!ctx||!artWidth||!artHeight)return;
    ctx.clearRect(0,0,artWidth,artHeight);
    const w=artWidth,h=artHeight,middle=w*.5,centre=h*.49,top=80,bottom=h-64;
    const scrollPhase=readY/Math.max(1,width),intro=reduced.matches?1:limit(heroElapsed/heroDuration);
    const sway=Math.sin(scrollPhase*.8)*2.5;
    const active=heroStarted&&heroElapsed<heroDuration&&!reduced.matches;
    const baseProgress=active?intro:1;
    const bead=(p,t,r,colour)=>{
      if(t<=0||t>=1||reduced.matches)return;
      const m=1-t,x=m*m*m*p[0].x+3*m*m*t*p[1].x+3*m*t*t*p[2].x+t*t*t*p[3].x;
      const y=m*m*m*p[0].y+3*m*m*t*p[1].y+3*m*t*t*p[2].y+t*t*t*p[3].y;
      ctx.beginPath();ctx.arc(x,y,r,0,Math.PI*2);ctx.fillStyle=colour;ctx.fill();
    };
    const line=(p,colour,strokeWidth)=>{
      ctx.beginPath();ctx.moveTo(p[0].x,p[0].y);ctx.bezierCurveTo(p[1].x,p[1].y,p[2].x,p[2].y,p[3].x,p[3].y);
      ctx.strokeStyle=colour;ctx.lineWidth=strokeWidth;ctx.stroke();
    };
    ctx.beginPath();ctx.ellipse(middle,centre,w*.40,Math.min(h*.19,57),0,0,Math.PI*2);ctx.strokeStyle='rgba(13,31,182,.075)';ctx.lineWidth=.7;ctx.stroke();
    for(let family=0;family<2;family++){
      const start=w*(family?.76:.24),colour=family?'13,31,182':'209,36,41';
      for(let i=0;i<13;i++){
        const offset=(i-6)*1.4;
        const p=[{x:start+offset,y:top},{x:start+offset+sway,y:top+34},{x:middle+offset+(family?26:-26),y:centre-27},{x:middle+offset,y:centre}];
        line(p,'rgba('+colour+','+(i===6?.65:.11)+')',i===6?1.15:.65);
        if(i===6||i===3||i===9){
          const progress=baseProgress/.49-(i-3)*.019;
          bead(p,progress,i===6?2.2:1.2,'rgba('+colour+','+(i===6?.9:.55)+')');
          if(i===6)bead(p,progress-.05,1.1,'rgba('+colour+',.24)');
        }
      }
    }
    for(let output=0;output<3;output++){
      const dest=w*[.18,.5,.82][output];
      const p=[{x:middle,y:centre+18},{x:middle+sway*.3,y:centre+66},{x:dest,y:bottom-40},{x:dest,y:bottom}];
      for(let strand=-2;strand<=2;strand++)line(p.map(point=>({x:point.x+strand*1.6,y:point.y})),'rgba(98,113,158,'+(strand===0?.45:.10)+')',strand===0?.9:.65);
      const progress=(baseProgress-.40)/.60;
      bead(p,progress,1.9,'rgba(13,31,182,.72)');
      bead(p,progress-.07,1.1,'rgba(13,31,182,.25)');
    }
    canvas.dataset.motionFrame=(baseProgress+scrollPhase).toFixed(4);
  }
  function render(){background();sculpture();}
  function tick(now){
    raf=0;if(paused||document.hidden||!root.isConnected)return;
    if(now-lastDraw<30){raf=requestAnimationFrame(tick);return;}
    const frameTime=lastDraw?Math.min(64,now-lastDraw):33;lastDraw=now;
    if(heroRunning())heroElapsed=Math.min(heroDuration,heroElapsed+frameTime);
    const delta=targetY-readY;readY+=delta*.2;if(Math.abs(delta)<.5)readY=targetY;
    render();if(Math.abs(targetY-readY)>.5||heroRunning())raf=requestAnimationFrame(tick);
  }
  function requestDraw(){if(!paused&&!raf&&!document.hidden)raf=requestAnimationFrame(tick);}
  function setView(top,bottom){
    viewTop=limit(top,0,root.offsetHeight);viewBottom=limit(bottom,viewTop,root.offsetHeight);
    const visibleHeight=Math.max(260,Math.min(1100,viewBottom-viewTop));
    root.rxViewport={top:viewTop,bottom:viewBottom};
    root.dispatchEvent(new CustomEvent('rx:viewport',{detail:root.rxViewport}));
    const hold=root.rxScrollHold;
    targetY=limit(viewTop-(hold?hold.shift:0)+visibleHeight*.60,0,height);
    if(hold&&hold.active)readY=targetY;
    requestDraw();
  }
  function syncWindow(){
    const box=root.getBoundingClientRect();
    if(root.dataset.scrollDriver==='native'||window.innerHeight<root.offsetHeight*.8||window.scrollY>0)setView(-box.top,-box.top+window.innerHeight);
  }
  function syncBands(entries){
    if(window.innerHeight<root.offsetHeight*.8&&window.scrollY>0){syncWindow();return;}
    entries.forEach(e=>{if(e.isIntersecting&&e.intersectionRect.height>0)visibleBands.set(e.target,e.intersectionRect);else visibleBands.delete(e.target);});
    if(!visibleBands.size)return;
    const rect=root.getBoundingClientRect();let top=Infinity,bottom=-Infinity;
    visibleBands.forEach(r=>{top=Math.min(top,r.top);bottom=Math.max(bottom,r.bottom);});
    if(Number.isFinite(top)&&Number.isFinite(bottom))setView(top-rect.top,bottom-rect.top);
  }
  function makeBands(){
    if(root.dataset.scrollDriver==='native')return;
    const fullHeight=root.offsetHeight,count=Math.ceil(fullHeight/88);if(count===lastBandCount)return;lastBandCount=count;
    if(observer)observer.disconnect();visibleBands.clear();bands.replaceChildren();
    if(!('IntersectionObserver'in window))return;
    observer=new IntersectionObserver(syncBands,{threshold:Array.from({length:89},(_,i)=>i/88)});
    for(let i=0;i<count;i++){const band=document.createElement('div');band.className='rx-scroll-band';band.style.top=i*88+'px';band.style.height=Math.min(88,fullHeight-i*88)+'px';bands.appendChild(band);observer.observe(band);}
  }
  function layout(){
    if(layoutBusy||!root.isConnected)return;layoutBusy=true;
    width=root.clientWidth;height=Math.max(1,localTop(footer));svg.setAttribute('viewBox','0 0 '+width+' '+page.offsetHeight);
    const group=q('#rx-group'),eco=q('#rx-ecosystem'),products=q('#rx-platforms'),global=q('#rx-global'),contact=q('#rx-contact');
    anchors=[{y:0,x:width*.93},{y:localTop(group)*.66,x:width*.94},{y:localTop(group)+group.offsetHeight*.47,x:width*.14},{y:localTop(eco),x:width*.04},{y:localTop(eco)+eco.offsetHeight*.60,x:width*.90},{y:localTop(products)+products.offsetHeight*.38,x:width*.92},{y:localTop(global),x:width*.18},{y:localTop(global)+global.offsetHeight*.68,x:width*.04},{y:localTop(contact)+contact.offsetHeight*.22,x:width*.90},{y:height,x:width*.53}];
    sectionPositions=sections.map(el=>({el,top:localTop(el),bottom:localTop(el)+el.offsetHeight}));
    const box=canvas.getBoundingClientRect(),dpr=Math.min(window.devicePixelRatio||1,2);artWidth=box.width;artHeight=box.height;
    if(ctx){canvas.width=Math.round(artWidth*dpr);canvas.height=Math.round(artHeight*dpr);ctx.setTransform(dpr,0,0,dpr,0,0);}
    makeBands();syncWindow();if(readY===0)readY=targetY||360;render();layoutBusy=false;
  }
  function controls(){root.dataset.motion=paused?'paused':'scroll';}
  listen(window,'scroll',syncWindow,{passive:true});listen(window,'resize',layout,{passive:true});
  listen(document,'visibilitychange',()=>{if(document.hidden&&raf){cancelAnimationFrame(raf);raf=0;}else requestDraw();});
  listen(reduced,'change',()=>{paused=reduced.matches;controls();render();requestDraw();});
  if('ResizeObserver'in window)new ResizeObserver(layout).observe(root);
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(()=>{if(root.isConnected)layout();});
  if('IntersectionObserver'in window)new IntersectionObserver(entries=>{
    const entry=entries[0];heroOnScreen=entry.isIntersecting;
    if(heroOnScreen){heroStarted=true;requestDraw();}
  },{threshold:.12}).observe(canvas);
  else{heroOnScreen=true;heroStarted=true;}
  qa('.rx-product-tab').forEach((t,i)=>t.tabIndex=i===0?0:-1);
  controls();layout();
})();

(function(){
  const root=document.getElementById('rx-home'),product=document.getElementById('rx-prism-model');
  if(!root||!product||product.dataset.ready)return;product.dataset.ready='true';
  const canvas=product.querySelector('canvas'),ctx=canvas.getContext('2d');if(!ctx)return;
  const page=document.getElementById('rx-page-stage'),groupPin=document.getElementById('rx-model-pin');
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)'),TAU=Math.PI*2;
  const clamp=x=>Math.max(0,Math.min(1,x)),lerp=(a,b,t)=>a+(b-a)*t;
  const models=content.models;
  const state={ctx,w:0,h:0,position:0,target:0,step:-1,key:'health'};
  const buttons=[...product.querySelectorAll('[data-prism-step]')],hint=product.querySelector('#rx-prism-hint');
  function marker(){const el=document.createElement('span');el.className='rx-model-stop';el.setAttribute('aria-hidden','true');root.appendChild(el);return el;}
  const stops=buttons.map(marker),navStop=marker();
  let view=root.rxViewport||{top:0,bottom:800},mode='',distance=0,inset=24,lockStart=0,drawRaf=0;
  const motionAllowed=()=>!reduced.matches&&root.dataset.motion!=='paused';
  function localY(element){let y=0;for(let node=element;node&&node!==page;node=node.offsetParent)y+=node.offsetTop;return y;}
  function stroke(ctx,points,colour,width){ctx.beginPath();points.forEach((p,i)=>i?ctx.lineTo(p.x,p.y):ctx.moveTo(p.x,p.y));ctx.strokeStyle=colour;ctx.lineWidth=width;ctx.stroke();}
  function dot(ctx,x,y,r,colour){ctx.beginPath();ctx.arc(x,y,r,0,TAU);ctx.fillStyle=colour;ctx.fill();}
  function prism(s){
    const{ctx,w,h,position}=s;
    const scale=Math.min(w*.24,h*.34),cx=w*.51,cy=h*.43,yaw=-.48+position*.36,tilt=.29,roll=.12;
    function project(a){const[x,y,z]=a;const xx=x*Math.cos(yaw)+z*Math.sin(yaw),zz=-x*Math.sin(yaw)+z*Math.cos(yaw),yy=y*Math.cos(tilt)-zz*Math.sin(tilt),depth=y*Math.sin(tilt)+zz*Math.cos(tilt),f=5.2/(5.2+depth);return{x:cx+(xx*Math.cos(roll)-yy*Math.sin(roll))*scale*f,y:cy+(xx*Math.sin(roll)+yy*Math.cos(roll))*scale*f,z:depth};}
    function polygon(points){ctx.beginPath();points.forEach((p,i)=>i?ctx.lineTo(p.x,p.y):ctx.moveTo(p.x,p.y));ctx.closePath();}
    ctx.save();ctx.translate(cx,h*.85);ctx.scale(1,.18);const shadow=ctx.createRadialGradient(0,0,0,0,0,scale*1.4);shadow.addColorStop(0,'rgba(55,60,56,.12)');shadow.addColorStop(.5,'rgba(55,60,56,.035)');shadow.addColorStop(1,'rgba(55,60,56,0)');ctx.fillStyle=shadow;ctx.beginPath();ctx.arc(0,0,scale*1.4,0,TAU);ctx.fill();ctx.restore();
    const raw=[[0,-1.10,-.67],[1.1,.82,-.67],[-1.1,.82,-.67],[0,-1.10,.67],[1.1,.82,.67],[-1.1,.82,.67]],vertices=raw.map(project);
    const left=project([-.64,.12,0]),right=project([.64,.12,0]);
    for(let n=-2;n<=2;n++)stroke(ctx,[{x:0,y:h*.52+n*4},{x:left.x,y:left.y+n*1.6}],n===0?'rgba(209,36,41,.48)':'rgba(135,143,135,.12)',n===0?.9:.5);
    const faces=[[0,2,1],[3,4,5],[0,1,4,3],[1,2,5,4],[2,0,3,5]].map((ids,i)=>({points:ids.map(j=>vertices[j]),index:i,depth:ids.reduce((a,j)=>a+vertices[j].z,0)/ids.length})).sort((a,b)=>b.depth-a.depth);
    for(const face of faces){
      const pts=face.points;polygon(pts);
      const gradient=ctx.createLinearGradient(cx-scale,cy-scale,cx+scale,cy+scale);
      gradient.addColorStop(0,'rgba(255,255,255,.85)');gradient.addColorStop(.42,face.index%2?'rgba(244,246,244,.42)':'rgba(230,234,230,.40)');gradient.addColorStop(.66,'rgba(255,255,255,.30)');gradient.addColorStop(1,'rgba(208,215,209,.53)');
      ctx.fillStyle=gradient;ctx.fill();ctx.strokeStyle=face.depth>0?'rgba(129,140,130,.25)':'rgba(118,132,120,.52)';ctx.lineWidth=face.depth>0?.55:.85;ctx.stroke();
      if(pts.length===4){
        for(let n=1;n<19;n++){const t=n/19,p={x:lerp(pts[0].x,pts[1].x,t),y:lerp(pts[0].y,pts[1].y,t)},q={x:lerp(pts[3].x,pts[2].x,t),y:lerp(pts[3].y,pts[2].y,t)};stroke(ctx,[p,q],'rgba(113,130,116,.075)',.5);}
      }else{
        for(let n=1;n<9;n++){const t=n/11,p={x:lerp(pts[0].x,pts[1].x,t),y:lerp(pts[0].y,pts[1].y,t)},q={x:lerp(pts[0].x,pts[2].x,t),y:lerp(pts[0].y,pts[2].y,t)};stroke(ctx,[p,q],'rgba(121,137,125,.055)',.5);}
      }
    }
    for(let faceZ of [-.67,.67]){
      const inset=[[0,-1.025,faceZ],[1.02,.775,faceZ],[-1.02,.775,faceZ]].map(project);polygon(inset);ctx.strokeStyle='rgba(255,255,255,.90)';ctx.lineWidth=1.3;ctx.stroke();
    }
    const middle=project([0,.12,0]);stroke(ctx,[left,middle,right],'rgba(209,36,41,.46)',.8);
    for(let n=-2;n<=2;n++)stroke(ctx,[{x:right.x,y:right.y+n*1.6},{x:w,y:h*.43+n*4}],n===0?'rgba(209,36,41,.57)':'rgba(135,143,135,.12)',n===0?.95:.5);
    const phase=position/2;dot(ctx,lerp(left.x,right.x,phase),lerp(left.y,right.y,phase),2.1,'rgba(209,36,41,.80)');
  }

  function draw(){if(!state.w)return;ctx.clearRect(0,0,state.w,state.h);prism(state);canvas.dataset.stage=state.position.toFixed(3);}
  function requestDraw(){if(drawRaf)return;drawRaf=requestAnimationFrame(()=>{drawRaf=0;draw();});}
  function resize(){
    const box=canvas.getBoundingClientRect();if(!box.width)return;
    const ratio=Math.min(window.devicePixelRatio||1,2);
    state.w=box.width;state.h=box.height;canvas.width=Math.round(box.width*ratio);canvas.height=Math.round(box.height*ratio);ctx.setTransform(ratio,0,0,ratio,0,0);draw();
  }
  function label(index,force=false){
    if(index===state.step&&!force)return;state.step=index;
    const model=models[state.key];
    product.querySelector('#rx-prism-count').textContent='0'+(index+1)+' / 03';
    buttons.forEach((button,i)=>{button.setAttribute('aria-pressed',String(i===index));button.setAttribute('aria-label',model.steps[i]+': '+model.subjects[i]);button.querySelector('strong').textContent=model.steps[i];});
    product.querySelector('#rx-prism-title').replaceChildren(document.createTextNode(model.steps[index]+'.'),Object.assign(document.createElement('span'),{textContent:model.subjects[index]}));
    updateHint();
  }
  function updateHint(){const text=mode==='none'?content.labels.three:state.target>=2?content.labels.continue:content.labels.scroll;if(hint.textContent!==text)hint.textContent=text;}
  function configure(){
    const visibleHeight=Math.max(0,view.bottom-view.top),wide=root.clientWidth>650;
    const next=reduced.matches?'none':wide&&visibleHeight>=groupPin.offsetHeight+40?'group':'prism';
    if(next!==mode){
      mode=next;root.dataset.modelPin=mode;distance=mode==='none'?0:mode==='group'?1100:960;
      root.style.setProperty('--rx-page-travel',distance+'px');updateHint();
    }
    if(mode==='none')return;
    const headingTop=localY(root.querySelector('#rx-platforms > .rx-platform-top'));
    const completeHeight=localY(groupPin)+groupPin.offsetHeight-headingTop;
    if(mode==='group'&&completeHeight<=visibleHeight-40){
      inset=Math.max(20,Math.min(40,(visibleHeight-completeHeight)/2));lockStart=headingTop-inset;
    }else{
      const anchor=mode==='group'?groupPin:product;inset=24;
      lockStart=localY(anchor)-inset;
    }
    root.style.setProperty('--rx-page-lock-top',-lockStart+'px');
    stops.forEach((stop,i)=>{stop.style.top=(lockStart+distance*i/2)+'px';});
  }
  function scrub(nextView){
    if(!root.isConnected)return;
    if(nextView&&Number.isFinite(nextView.top)&&Number.isFinite(nextView.bottom))view=nextView;
    configure();
    const progress=distance?clamp((view.top-lockStart)/distance):0,shift=progress*distance;
    if(root.dataset.scrollDriver!=='native')root.style.setProperty('--rx-page-shift',shift.toFixed(3)+'px');
    root.rxScrollHold={shift,start:lockStart,end:lockStart+distance,distance,active:distance>0&&view.top>=lockStart&&view.top<lockStart+distance};
    root.dataset.pageHeld=String(root.rxScrollHold.active);
    product.dataset.scrollProgress=progress.toFixed(4);
    if(mode==='none')return;
    state.target=progress*2;
    label(Math.round(state.target));
    updateHint();
    if(motionAllowed()){state.position=state.target;requestDraw();}
  }
  function select(index){
    if(mode!=='none'){
      stops[index].scrollIntoView({behavior:motionAllowed()?'smooth':'instant',block:'start'});
    }else{state.position=state.target=index;label(index);draw();}
  }
  function setPlatform(key){
    if(!models[key])return;state.key=key;const model=models[key];product.dataset.platform=key;
    product.querySelector('#rx-product-caption').textContent=model.caption;
    product.querySelector('#rx-prism-foot-label').textContent=model.footer;
    product.querySelector('.rx-prism-selectors').setAttribute('aria-label',content.labels.explore+' '+model.caption.toLowerCase());
    canvas.setAttribute('aria-label',model.description+' '+content.labels.prism_help);
    label(Math.max(0,state.step),true);scrub();
  }
  buttons.forEach((button,i)=>listen(button,'click',()=>select(i)));
  root.rxNavigate=target=>{
    configure();
    const local=target.getBoundingClientRect().top-page.getBoundingClientRect().top;
    const destination=Math.max(0,local-(parseFloat(getComputedStyle(target).scrollMarginTop)||0));
    navStop.style.top=(destination+(distance&&destination>=lockStart?distance:0))+'px';
    navStop.scrollIntoView({behavior:reduced.matches?'instant':'smooth',block:'start'});
  };
  listen(root,'rx:platform',event=>setPlatform(event.detail.key));
  listen(root,'rx:viewport',event=>scrub(event.detail));
  if('ResizeObserver'in window){
    new ResizeObserver(resize).observe(canvas);
    const observer=new ResizeObserver(()=>scrub());observer.observe(page);observer.observe(groupPin);observer.observe(product);
  }
  listen(window,'resize',()=>{resize();scrub();},{passive:true});
  new MutationObserver(()=>{if(motionAllowed()){state.position=state.target;requestDraw();}}).observe(root,{attributes:true,attributeFilter:['data-motion']});
  listen(reduced,'change',()=>{scrub();if(reduced.matches){state.position=state.target=state.step;draw();}});
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(()=>{if(root.isConnected){resize();scrub();}});
  product.dataset.platform='health';resize();label(0);scrub();
})();


  }
  initialize();
  document.addEventListener('shopify:section:load',initialize);
  document.addEventListener('shopify:section:unload',event=>{if(event.target.querySelector('#rx-home'))teardown?.();});
  document.addEventListener('shopify:block:select',event=>{const root=document.getElementById('rx-home');if(root?.contains(event.target))root.rxNavigate?.(event.target);});
})();
